<template>
    <div class="sidebarSearch">

      <ion-searchbar @ionChange="eventSearch" :placeholder="general.searchPlaceholder" ></ion-searchbar>

      <div class="wrapper">
        <div class="wrapper-buttons">
          <div class="select__wrapper">
            <font-awesome-icon :icon="['far', 'chevron-down']" />
            <b-form-select v-model="selected" :options="options.options" class="select">
            </b-form-select>
          </div>

          <!-- <b-button class="btn bt-white" v-b-toggle="'collapse-filter'"> -->
          <b-button class="btn bt-white">
            <span><font-awesome-icon :icon="['fas', 'sliders-h']" /></span>
            <span>{{general.filter}}</span>     
          </b-button>
        </div>

        <b-collapse id="collapse-filter" class="mt-2">
          <b-form-group label="Filtres">
            <b-form-checkbox-group
              id="checkbox-group-1"
              v-model="selectFilter"
              :options="options.filters"
              switches
            ></b-form-checkbox-group>
          </b-form-group>
          <b-button class='btn btn-white' v-b-toggle="'collapse-filter'">{{general.formBtApply}}</b-button>
        </b-collapse>   


        <!-- <ion-list> -->
          <b-list-group>
            <b-list-group-item  v-for="commercial in filteredList" :key="commercial.id">
              <b-button class="btn-listSearch">
                <div class="title"><PuSkeleton>{{commercial.fullname}}</PuSkeleton></div>
                <div class="right" :class="commercial.class">
                  <span>
                    <PuSkeleton circle height="50px">
                      <font-awesome-icon :icon="['far', commercial.icon]" />
                    </PuSkeleton>
                  </span>
                  <PuSkeleton><div class="number">{{commercial.number}}</div></PuSkeleton>
                </div>              
              </b-button>
            </b-list-group-item>
          </b-list-group>
        <!-- </ion-list> -->

      </div>

    </div>

</template>

<script>
import { mapGetters } from 'vuex'


export default {
  name: "SidebarSearch",

  components: {
  },
  
  data() {
    return {
        commercials: [],
        search: '',
        general:[], 
        selectFilter: [],
        selected: null,
                  
    }
  },
  computed: {
    ...mapGetters([
      'getCommercials',
      'getGeneral',
      'getSideSearch'
    ]),
    filteredList() {
      return this.commercials.filter(commercial => {
        return commercial.fullname.toLowerCase().includes(this.search.toLowerCase())
      }) 
    }
  },
  created (){
    this.commercials= this.getCommercials;
    this.general= this.getGeneral;
    this.options= this.getSideSearch;
    //
  },
  methods: {
    eventSearch : function(event){
      this.search = event.target.value;
    },
    reverse: function () {
       this.commercials =  this.commercials.reverse();
    }
  }
}
</script>